module.exports = __webpack_public_path__ + "assets/6b88954ae9d1084983867796b4115d87.mp3";